<script>
  import Button from '$components/elements/Button.svelte';
  import BasicLogo from '$components/logo/BasicLogo.svelte';
  import { PUBLIC_APP_URL } from '$env/static/public';
  import { adminMode } from '$lib/stores';

  export let darkMode = false;
  export let isEmbedded = false;
</script>

<nav class="menu" class:menu--dark={darkMode} class:menu--admin={$adminMode}>
  {#if !isEmbedded}
    {#if $adminMode}
      <div class="menu__admin">
        Máte zapnutý administrační mód. Nyní můžete upravovat texty a obrázky, nebo můžete
        <Button slimness="super-slim" href="{PUBLIC_APP_URL}/admin">přejít do administrace</Button>
      </div>
    {/if}
    <a class="menu__logo" href="/"><BasicLogo {darkMode} /></a>
  {/if}
  <slot />
</nav>

<style lang="scss">
  .menu {
    width: 100%;
    display: flex;
    align-items: center;

    height: 89px;
    position: fixed;
    top: 0;

    z-index: 100;
    background-color: $color-white;
    border-bottom: 1px solid $color-medium-gray;
    transition: 0.3s ease all;
    &--dark {
      background-color: $color-dark-gray;
    }

    &--admin {
      height: 153px;
      padding-top: 64px;
    }

    &__logo {
      display: block;
      padding-left: 60px;
      padding-right: 55px;
    }
    &__admin {
      height: 64px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      border-bottom: 1px solid $color-dark-gray;
      display: flex;
      padding: 0 69px;
      align-items: center;
      gap: 8px;
      justify-content: center;
    }
  }
  @include mobile {
    .menu {
      justify-content: space-between;
      height: 56px;
      &__logo {
        display: inline-block;
        padding-left: 17px;
      }
    }
  }
</style>
